module.exports = __webpack_public_path__ + "static/media/011-rhombus-orange.56cc95d6.svg";